import { z } from 'zod';

export enum TwoStepProcessPaymentFormField {
    payerAccountId = 'payerAccountId',
    invoiceIds = 'invoiceIds',
}

export const TwoStepProcessPaymentInvoiceIdsSchema = z.object({
    [TwoStepProcessPaymentFormField.invoiceIds]: z.array(z.string()).nullish(),
    [TwoStepProcessPaymentFormField.payerAccountId]: z.string().min(1),
});

export type TwoStepProcessPaymentFormModel = z.infer<typeof TwoStepProcessPaymentInvoiceIdsSchema>;
